import React from "react";
import CTable from "components/common/Table";
import { withRouter } from "react-router";

const CustomerSearchHistoryTabs = ({ data, loading }) => {
 
  const columns = [
    { field: "station_name", headerName: "Charging Station" },
    {field: "network",headerName:'Network'},
    { field: "date", headerName: "Date" },
    { field: "time", headerName: "Time" },
    { field: "check_in", headerName: "Check In" },
  ];

  return (
    <CTable
      columns={columns}
      data={data}
      isLoading={loading?.isLoading}
      pagination
      localPagination
      page={0}
      rowsPerPage={5}
    />
  );
};

export default withRouter(CustomerSearchHistoryTabs);
